/**
 * Minimal, robust HTTP client using XMLHttpRequest (compatible with existing FakeXHR in tests).
 * - Promise-based API
 * - Timeout support
 * - Abort handle
 */
export default class HttpClient {
    static request(opts) {
        const method = (opts.method || 'GET').toUpperCase();
        const xhr = new XMLHttpRequest();
        const promise = new Promise((resolve, reject) => {
            xhr.open(method, opts.url);
            if (opts.withCredentials) {
                xhr.withCredentials = true;
            }
            if (opts.timeoutMs && opts.timeoutMs > 0) {
                xhr.timeout = opts.timeoutMs;
            }
            if (opts.headers) {
                for (const [k, v] of Object.entries(opts.headers)) {
                    try {
                        xhr.setRequestHeader(k, String(v));
                    }
                    catch (_a) {
                        // ignore header set errors
                    }
                }
            }
            xhr.onload = function () {
                var _a;
                resolve({
                    status: this.status,
                    body: (_a = this.responseText) !== null && _a !== void 0 ? _a : '',
                    xhr
                });
            };
            xhr.onerror = function () {
                reject({
                    status: xhr.status || 0,
                    body: '',
                    xhr
                });
            };
            xhr.ontimeout = function () {
                reject({
                    status: xhr.status || 0,
                    body: '',
                    xhr
                });
            };
            try {
                xhr.send(opts.body);
            }
            catch (err) {
                reject({
                    status: xhr.status || 0,
                    body: '',
                    xhr
                });
            }
        });
        const abort = () => {
            try {
                // Clear handlers before abort to avoid firing user callbacks post-abort
                xhr.onload = null;
                xhr.onerror = null;
                xhr.ontimeout = null;
                xhr.abort();
            }
            catch (_a) {
                // ignore
            }
        };
        return { promise, abort, xhr };
    }
}
